/* ==========================================================================
   PrettyRobes — Pet Shoulder Bags single-product feature section
   Scoped to .psb-page so listeners cannot collide with Dawn / pr-product1.js
   ========================================================================== */
(function () {
  'use strict';

  function init(root) {
    if (!root) return;

    // FAQ accordion
    root.querySelectorAll('.faq-item').forEach(function (item) {
      var btn = item.querySelector('.faq-q');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var open = item.getAttribute('aria-expanded') === 'true';
        item.setAttribute('aria-expanded', String(!open));
        btn.setAttribute('aria-expanded', String(!open));
      });
    });

    // Gallery thumbnail clicks — swap into the main slot.
    // Scoped to .psb-gallery so it can't collide with .pr-main-product-section.
    var gallery = root.querySelector('.psb-gallery');
    if (gallery) {
      var mainSlot = gallery.querySelector('.psb-gallery-main img');
      gallery.querySelectorAll('button.psb-gallery-thumb, a.psb-gallery-thumb').forEach(function (thumb) {
        thumb.addEventListener('click', function (e) {
          var img = thumb.querySelector('img');
          if (!img || !mainSlot) return;
          e.preventDefault();
          var nextSrc = img.getAttribute('src');
          var nextSrcset = img.getAttribute('srcset');
          var nextAlt = img.getAttribute('alt') || '';
          if (nextSrc) mainSlot.setAttribute('src', nextSrc);
          if (nextSrcset) mainSlot.setAttribute('srcset', nextSrcset);
          mainSlot.setAttribute('alt', nextAlt);
        });
      });
    }

    // Variant <select> → keep buy-form variant id and price in sync.
    var form = root.querySelector('form[data-psb-buy-form]');
    if (form) {
      var variantInput = form.querySelector('input[name="id"]');
      var variantSelect = root.querySelector('select[data-psb-variant-select]');
      var nowEl = root.querySelector('.feat-price .now');
      var wasEl = root.querySelector('.feat-price .was');
      if (variantSelect && variantInput) {
        variantSelect.addEventListener('change', function () {
          var opt = variantSelect.options[variantSelect.selectedIndex];
          if (!opt) return;
          variantInput.value = opt.value;
          if (nowEl && opt.dataset.price) nowEl.textContent = opt.dataset.price;
          if (wasEl && opt.dataset.compare) {
            wasEl.textContent = opt.dataset.compare;
            wasEl.style.display = '';
          } else if (wasEl) {
            wasEl.style.display = 'none';
          }
        });
      }
    }
  
  // Trust review link → smooth scroll to reviews section
  var trustReviewLinks = root.querySelectorAll('.trust-review-link');
  trustReviewLinks.forEach(function (link) {
    link.addEventListener('click', function (e) {
      var href = link.getAttribute('href');
      if (href && href.charAt(0) === '#') {
        var target = document.getElementById(href.slice(1));
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    });
  });

  // Hero image click → smooth scroll to the grid section
  root.querySelectorAll('.hero-scroll-link').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var href = link.getAttribute('href');
      if (href && href.charAt(0) === '#') {
        var target = document.getElementById(href.slice(1));
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    });
  });
}

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('.psb-page').forEach(init);
    });
  } else {
    document.querySelectorAll('.psb-page').forEach(init);
  }
})();
